import { NavigationService } from '../../services/navigation';

export const ACCOUNT_TAB = [
  {
    icon: require('../../assets/my-profile.png'),
    title: 'My profile',
    onPress: () => {
      NavigationService.push('Root', {
        screen: 'MyAccountTab',
      });
    },
  },
  {
    icon: require('../../assets/my-account-statement.png'),
    title: 'My account\nStatement',
    onPress: () => {
      NavigationService.push('AccountStatememt');
    },
  },
  {
    icon: require('../../assets/my-bookings.png'),
    title: 'My bookings',
    onPress: () => {
      // NavigationService.navigate('MyBookings')
      NavigationService.push('Root', {
        screen: 'MyBookingsTab',
      });
    },
  },
  {
    icon: require('../../assets/my-orders.png'),
    title: 'My orders',
    onPress: () => {
      // NavigationService.navigate('MyOrders')
      NavigationService.push('Root', {
        screen: 'MyOrdersTab',
      });
    },
  },
  {
    icon: require('../../assets/my-account-statement.png'),
    title: 'My Preferences',
    onPress: () => {
      NavigationService.push('MyPreferences');
    },
  },
];
